import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[editMode]',
  standalone: true,
})
export class EditModeDirective {
  public tpl = inject<TemplateRef<any>>(TemplateRef<any>);
}
